<template>
  <div>
    <List border size="small" style="width: 50%">
      <ListItem>
        <h4>需求详细信息</h4>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">需求科室:</Col>
        <Col span="">{{ data.deskName }}</Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">发起人:</Col>
        <Col span="">{{ data.proposerName }}</Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">需求内容:</Col>
        <Col span="">{{ data.content }}</Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">需求原因:</Col>
        <Col span="">{{ data.reason }}</Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">紧急程度:</Col>
        <Col span="">{{
          data.urgency == 1
            ? "一般"
            : data.urgency == 2
            ? "较重要"
            : data.urgency == 3
            ? "重要"
            : data.urgency == 4
            ? "特别重要"
            : ""
        }}</Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">相关文件:</Col>
        <Col span="">
          <p @click="handleRender(data.demandFileUrl)">
            <svg
              t="1686795127586"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="7800"
              width="20"
              height="20"
            >
              <path
                d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                fill="#CCA352"
                p-id="7801"
              ></path>
              <path
                d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                fill="#FFFFFF"
                p-id="7802"
              ></path>
              <path
                d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                fill="#FFCC66"
                p-id="7803"
              ></path>
            </svg>
          </p>
        </Col>
      </ListItem>
      <ListItem>
        <Col span="3" class="title">接单人:</Col>
        <Col span="">{{ data.accepterName }}</Col>
      </ListItem>
      <template v-for="item in data.demandHistoryList">
        <ListItem :key="item.newAssigneeName">
          <Col span="3" class="title">指派负责人:</Col>
          <Col span="">{{ item.newAssigneeName }}</Col>
        </ListItem>
        <ListItem :key="item.id">
          <Col span="3" class="title">状态:</Col>
          <Col span="">{{
            item.newStatus == 0
              ? "待受理"
              : item.newStatus == 1
              ? "不予受理"
              : item.newStatus == 2
              ? "处理中"
              : item.newStatus == 3
              ? "处理完成"
              : item.newStatus == 4
              ? "待立项"
              : ""
          }}</Col>
        </ListItem>
      </template>
    </List>
  </div>
</template>

<script>
import config from "../../../config";
export default {
  data() {
    return {
      data: {},
    };
  },
  created() {
    let query = this.$route.query;
    if (query.kv) {
      this.load(query.kv);
    }
  },
  methods: {
    handleRender(text) {
      console.log("text", text);
      if (!text) {
        $utils.toast.error("暂无文件!");
        return;
      }
      const files = text.split(",").map((item) => {
        const [url, name] = item.split("#");
        return { url, name };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "500px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              {files.map((item, i) => (
                <div
                  style="display:flex;justify-content: space-between;border: 1px solid #dcdee2; padding: 10px;border-radius: 5px;"
                  key={i}
                >
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          );
        },
      });
    },

    async load(id) {
      $utils.api.load(`/admin/system/sysDemand/${id}`, {}).then((res) => {
        console.log(res);

        if (res && res.data) {
          if (res.data.applyFileUrl !== null) {
            res.data.applyFileUrl = config.IMAGE_HOST + res.data.applyFileUrl;
          }
          if (res.data.resultFileUrl !== null) {
            res.data.resultFileUrl = config.IMAGE_HOST + res.data.resultFileUrl;
          }
          this.data = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addactivity {
  margin-top: 10px;
}
</style>
